import { styled } from 'styled-components';

import { colors, gutterWidth } from '#/theme/theme';

export const CmsSplitContentBlockquote = styled.blockquote`
  padding: ${gutterWidth / 2}px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin: 0;

  @media (min-width: 768px) {
    padding: ${gutterWidth}px;
  }

  &::before {
    content: '“';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -35%);
    color: ${colors.brandYellow};
    font-size: 100px;
    font-weight: 700;
    line-height: 1;
  }
`;
